import React from 'react';
import { Link } from 'gatsby';
import { ReactComponent as RightArrowIcon } from '../../assets/images/right-arrow.svg';
import { css } from '@emotion/core';
import hexToRgba from 'hex-to-rgba';

interface LinkWithArrow {
  to: string;
  text: string;
  variant?: 'normal' | 'small';
}

const styles = {
  link: css`
    color: ${hexToRgba('#160B2C', 0.8)};
    text-transform: uppercase;
    &:hover {
      text-decoration: none;
    }
  `,
};

const LinkWithArrow: React.FC<LinkWithArrow> = ({
  to = '/',
  text = 'Read More',
  variant = 'normal',
}) => {
  const fontSize = variant === 'normal' ? 12 : 10;
  const scale = variant === 'normal' ? 0.8 : 0.6;
  const paddingLeft = variant === 'normal' ? 10 : 4;
  const top = variant === 'normal' ? 0 : -2;

  return (
    <Link to={to} css={[styles.link, { fontSize }]}>
      <span>{text}</span>
      <span css={{ paddingLeft, position: 'relative' }}>
        <RightArrowIcon
          css={{ transform: `scale(${scale})`, position: 'absolute', top }}
        />
      </span>
    </Link>
  );
};

export default LinkWithArrow;
